export type CohortLike = {
  id?: string;
  name?: string;
  is_active?: boolean;
  is_current?: boolean;
  role?: string;
  start_date?: string | null;
  end_date?: string | null;
};

export const getPrimaryCohort = <T extends CohortLike>(cohorts?: T[] | null): T | null => {
  if (!cohorts || cohorts.length === 0) return null;
  return cohorts.find((cohort) => cohort.is_current) ?? cohorts.find((cohort) => cohort.is_active) ?? cohorts[0] ?? null;
};

export const getPrimaryCohortRole = <T extends CohortLike>(cohorts?: T[] | null): string | undefined => {
  return getPrimaryCohort(cohorts)?.role;
};
